import { render, staticRenderFns } from "./YmapTonal.vue?vue&type=template&id=b6877bea&"
import script from "./YmapTonal.vue?vue&type=script&lang=js&"
export * from "./YmapTonal.vue?vue&type=script&lang=js&"
import style0 from "./YmapTonal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports